import PropTypes from 'prop-types';

function ZoomControls({ onZoomIn, onZoomOut, onZoomFit, onZoomActual, zoomLevel }) {
  return (
    <div className="zoom-controls">
      <button 
        onClick={onZoomIn}
        className="zoom-btn"
        title="Zoom In (Ctrl + Plus)"
        aria-label="Zoom in"
      >
        <span className="zoom-icon">+</span>
      </button>
      
      <button 
        onClick={onZoomOut}
        className="zoom-btn"
        title="Zoom Out (Ctrl + Minus)"
        aria-label="Zoom out"
      >
        <span className="zoom-icon">−</span>
      </button>
      
      <button 
        onClick={onZoomFit}
        className="zoom-btn"
        title="Fit to Screen (Ctrl + 0)"
        aria-label="Fit to screen"
      >
        <span className="zoom-icon">⛶</span>
      </button>
      
      <button 
        onClick={onZoomActual}
        className="zoom-btn"
        title="Actual Size (Ctrl + 1)"
        aria-label="Actual size"
      >
        <span className="zoom-icon">1:1</span>
      </button>
      
      <span className="zoom-level">{Math.round(zoomLevel * 100)}%</span>
    </div>
  );
}

ZoomControls.propTypes = {
  onZoomIn: PropTypes.func.isRequired,
  onZoomOut: PropTypes.func.isRequired,
  onZoomFit: PropTypes.func.isRequired,
  onZoomActual: PropTypes.func.isRequired,
  zoomLevel: PropTypes.number.isRequired
};

export default ZoomControls;
